import { createContext, useContext, useEffect, useState } from 'react';

const getSize = () => {
  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
  };
};

interface IContext {
  windowSize: {
    innerWidth: number;
    innerHeight: number;
  };
}

const initialState: IContext = {
  windowSize: {
    innerWidth: 0,
    innerHeight: 0,
  },
};

const StylesContext = createContext<IContext>(initialState);

const StylesProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [state, setState] = useState<IContext>(initialState);

  const handleResize = () => {
    setState((prev) => ({
      ...prev,
      windowSize: getSize(),
    }));
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <StylesContext.Provider value={state}>{children}</StylesContext.Provider>
  );
};

export default StylesProvider;

export const useStylesContext = () => {
  const context = useContext(StylesContext);

  if (context === undefined) {
    throw new Error('useStylesContext should be used inside a User provider');
  }
  return context;
};
